/**
 * ReactionViewer — la reazione video, aperta dalla notifica (#126).
 *
 * Chi crea tocca «Ti è arrivata una reazione» e la guarda qui, dentro l'app:
 * anche chi non ha un'email, e quindi non riceve il link per posta. Se il
 * telefono non riesce a riprodurre il video (un webm registrato su Android e
 * aperto su un iPhone vecchio), «Apri il video» lo passa al browser.
 *
 * Props:
 *   - videoUrl (string|null): link di Firebase Storage; null = chiuso
 *   - title (string): titolo del puzzle, se è tra «I miei puzzle»
 *   - onClose (fn)
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function ReactionViewer({ videoUrl, title, onClose }) {
  const { t } = useTranslation();
  if (!videoUrl) return null;

  return (
    <div
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="reaction-viewer-title"
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(8px)",
        zIndex: 320, display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--color-surface)", borderRadius: "2rem", padding: "24px 20px 20px", maxWidth: 440, width: "100%",
          boxShadow: "0 24px 64px rgba(0,0,0,0.2)", position: "relative", textAlign: "center",
        }}
      >
        <button
          onClick={onClose}
          aria-label={t("ui.signUp.closeAria")}
          style={{
            position: "absolute", top: 14, right: 14, background: "var(--color-bgAlt)", border: "none",
            borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "var(--color-textMuted)", fontSize: 16, fontWeight: 700,
          }}
        >
          ✕
        </button>
        <h2
          id="reaction-viewer-title"
          style={{ fontFamily: "var(--font-display)", fontSize: 20, fontWeight: 800, color: "var(--color-text)", margin: "4px 40px 4px" }}
        >
          {t("app.push.reactionTitle")}
        </h2>
        {title && (
          <p style={{ fontFamily: "var(--font-body)", fontSize: 13, color: "var(--color-textMuted)", margin: "0 0 14px" }}>
            {title}
          </p>
        )}
        <video
          src={videoUrl}
          controls
          autoPlay
          playsInline
          style={{ width: "100%", maxHeight: "60vh", borderRadius: 20, background: "#000", display: "block", marginTop: title ? 0 : 10 }}
        />
        <a
          href={videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block", marginTop: 14, fontFamily: "var(--font-body)", fontSize: 14,
            color: "var(--color-textMuted)", textDecoration: "underline",
          }}
        >
          {t("app.push.reactionOpen")}
        </a>
      </div>
    </div>
  );
}
